import ParticipantState from './participant'

export default class EmbedState extends ParticipantState {
  get defaultPage () {
    return 'blank'
  }

  // Force a reload for embeds as we don't have a proper UI for logging out
  logout () {
    this.get('session').destroy()
      .then(() => window.location.reload())
  }
}
